import { createSelector } from "@reduxjs/toolkit";
import initialState from "../redux/initialState"
import { RootState } from "types";


export const getFormsState = (state: RootState) => state.formsState || initialState

export const selectformData = createSelector(
    [getFormsState],
    (formsState)=>formsState.formData
)

export const selectIsLoading = createSelector(
    [getFormsState],
    (formsState)=>formsState.loading
)

export const selectFormState = createSelector(
    [getFormsState],
    (formsState)=>formsState.formState
)

export const selectPendingForm = createSelector(
    [getFormsState],
    (formsState)=>formsState.pendingForm
)


export const selectform = createSelector(
    [getFormsState],
    (formsState)=>formsState.formState
)

export const selectIsAddModalOpen = createSelector(
    [getFormsState],
    (formsState)=>formsState.isAddModalOpen
)

export const selectUploadedFile = createSelector(
    [getFormsState],
    (formsState)=>formsState.uploadedFile
)

export const selectUploadedFileError = createSelector(
    [getFormsState],
    (formsState)=>formsState.uploadedFileError
)
